<script setup>
import { Head } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'
import banker from '@/routes/banker'
import bankerVerification from '@/routes/banker/verification'

const { t } = useI18n()

defineProps({
  status: {
    type: String,
    default: null,
  },
})
</script>

<template>
  <Head :title="t('title')" />

  <AuthCard>
    <template #title>{{ t('title') }}</template>
    <template #content>
      <div class="flex flex-col gap-4">
        <p>{{ t('instruction') }}</p>
        <Message v-if="status" severity="success">
          {{ t('status.' + status) }}
        </Message>
      </div>
    </template>
    <template #footer>
      <div v-if="!status" class="flex justify-end gap-2">
        <Button v-slot="slotProps" :label="t('buttons.resend')" as-child>
          <Link :href="bankerVerification.send()" method="post" v-bind="slotProps">
            {{ t('buttons.resend') }}
          </Link>
        </Button>
        <Button v-slot="slotProps" :label="t('buttons.logout')" severity="secondary" as-child>
          <Link :href="banker.logout()" method="post" replace v-bind="slotProps">
            {{ t('buttons.logout') }}
          </Link>
        </Button>
      </div>
    </template>
  </AuthCard>
</template>

<i18n>
{
  "en": {
    "title": "Verify Email",
    "instruction": "We sent you an email with a verification link. Please check your inbox and click the link to verify your email address.",
    "buttons": {
      "resend": "Resend Email",
      "logout": "Logout"
    },
    "status": {
      "verification-link-sent": "A new verification link has been sent."
    }
  },
  "de": {
    "title": "E-Mail bestätigen",
    "instruction": "Wir haben Ihnen eine E-Mail mit einem Bestätigungslink gesendet. Bitte überprüfen Sie Ihr Postfach und klicken Sie auf den Link, um Ihre E-Mail-Adresse zu bestätigen.",
    "buttons": {
      "resend": "E-Mail erneut senden",
      "logout": "Abmelden"
    },
    "status": {
      "verification-link-sent": "Ein neuer Bestätigungslink wurde gesendet."
    }
  }
}
</i18n>
